<template>
    <div>
        <el-dialog title="新增" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="模块名称">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                  <el-form-item label="图标">
                        <el-input v-model="form.FIcon"></el-input>
                    </el-form-item>
                <el-form-item label="排序">
                    <el-input type="number" v-model="form.FSort"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
                <el-form-item label="ID">
                    <el-input :disabled="true" v-model="form.FID"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    export default {
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '模块名称', trigger: 'change'}]
                },
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            switchLoading(flag){
                this.loading = flag;
            },
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = Object.assign({id:0},record);
            },
            save:function () {
                util.post("server/system/Module.ashx?cmd=Save",this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/Module_Edit.vue